import React from 'react';
import { Language } from '../../types';

interface Props {
  language: Language;
}

const translations = {
  [Language.EN]: {
    owner: 'Owner',
    funding: 'Funding',
    budget: 'Budget',
    decisions: 'Decisions',
    visibility: 'Visibility',
    sharedProject: 'Shared Project',
    planning: 'Planning',
    procurement: 'Procurement',
    coordination: 'Coordination',
    delivery: 'Delivery',
  },
  [Language.ZH]: {
    owner: '业主',
    funding: '资金',
    budget: '预算',
    decisions: '决策',
    visibility: '可见性',
    sharedProject: '共享项目',
    planning: '规划',
    procurement: '采购',
    coordination: '协调',
    delivery: '交付',
  },
  [Language.VI]: {
    owner: 'Chủ sở hữu',
    funding: 'Tài trợ',
    budget: 'Ngân sách',
    decisions: 'Quyết định',
    visibility: 'Tính minh bạch',
    sharedProject: 'Dự án Chung',
    planning: 'Lập kế hoạch',
    procurement: 'Mua sắm',
    coordination: 'Điều phối',
    delivery: 'Bàn giao',
  },
  [Language.HI]: {
    owner: 'मालिक',
    funding: 'फंडिंग',
    budget: 'बजट',
    decisions: 'निर्णय',
    visibility: 'दृश्यता',
    sharedProject: 'साझा प्रोजेक्ट',
    planning: 'योजना',
    procurement: 'खरीद',
    coordination: 'समन्वयन',
    delivery: 'वितरण',
  },
};

export const OwnerPartnershipDiagram: React.FC<Props> = ({ language }) => {
  const t = translations[language] || translations[Language.EN];
  
  return (
    <div className="w-full flex flex-col my-4">
      {/* Owner Card */}
      <div className="bg-neutral-50 p-5 border-l-4 border-neutral-800 shadow-sm">
        <h4 className="text-xs uppercase tracking-widest font-bold mb-3 text-neutral-900 flex items-center justify-between">
          <span>{t.owner}</span>
          <i className="fa-solid fa-user-tie text-neutral-400"></i>
        </h4>
        <div className="grid grid-cols-2 gap-3 text-xs text-neutral-600">
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-300"></i> {t.funding}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-300"></i> {t.budget}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-300"></i> {t.decisions}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-300"></i> {t.visibility}</div>
        </div>
      </div>

      {/* Flow Indicator */}
      <div className="flex flex-col items-center justify-center py-2 relative">
        <div className="h-6 w-px bg-neutral-300"></div>
        <div className="absolute top-1/2 -translate-y-1/2 bg-white border border-neutral-200 px-4 py-1 text-[10px] uppercase tracking-widest text-neutral-500 shadow-sm z-10">
          {t.sharedProject}
        </div>
        <div className="h-6 w-px bg-neutral-300"></div>
      </div>

      {/* Le Sector Card */}
      <div className="bg-neutral-900 p-5 border-l-4 border-neutral-400 shadow-sm">
        <h4 className="text-xs uppercase tracking-widest font-bold mb-3 text-white flex items-center justify-between">
          <span>Le Sector</span>
          <i className="fa-solid fa-building text-neutral-500"></i>
        </h4>
        <div className="grid grid-cols-2 gap-3 text-xs text-neutral-400">
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-600"></i> {t.planning}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-600"></i> {t.procurement}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-600"></i> {t.coordination}</div>
          <div className="flex items-center gap-2"><i className="fa-solid fa-circle text-[6px] text-neutral-600"></i> {t.delivery}</div>
        </div>
      </div>
    </div>
  );
};
